<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`field_${_uid}`"
    :rules="rules"
    :custom-messages="{
      required: $t('validation.namedFieldIsMandatory', {
        field: localize(this.item.label)
      }),
      numeric: $t('validation.namedFieldIsNumeric', {
        field: localize(this.item.label)
      })
    }"
  >
    <v-text-field
      v-model.number="fieldValue"
      outlined
      flat
      hide-details="auto"
      :label="fieldLabel"
      :name="fieldLabel"
      :error-messages="errors"
    ></v-text-field>
  </ValidationProvider>
</template>

<script>
import { extend, ValidationProvider } from 'vee-validate';
import { numeric } from 'vee-validate/dist/rules';
import i18n from '@/i18n';

extend('numeric', {
  ...numeric,
  message: i18n.t('validation.fieldIsNumeric')
});

export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    rules() {
      if (this.item.fieldValidationMode === 2) {
        return 'required|numeric';
      }

      return '';
    }
  },

  components: {
    ValidationProvider
  }
};
</script>
